<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper :routerLink="'/adjustments'" min="0" max="1000" v-model="value.noise" label="menu.noise"/>
  </div>
</template>

<script lang="ts">
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Noise extends FilterMixin {

  protected filter = new Adjustments.Noise();

  protected value = { noise: 0 };
}

export default Noise;
</script>
